module.exports = __webpack_public_path__ + "static/media/28-6.20920b05.mp3";